import axios from "axios";

class DirectusHelper {
    baseUrl = "https://backoffice.indigen.com";

    async getData() {
        const showAll = location.href.includes("all");
        const items = [
            "projects",
            "team",
            "jobs",
            "references",
            "menu",
            "sections",
            "partners",
            "associates",
            "gallery",
        ];
        const results = {};
        for (let index in items) {
            const name = items[index];
            results[name] = await this.getItems(
                name,
                name === "projects" && showAll,
            );
        }
        return results;
    }

    async getItems(name, showAll = true) {
        const fields = "*.*.*";
        const url = `${this.baseUrl}/items/${name}`;
        const params = [];
        params.push(`fields=${fields}`);
        params.push(`filter[status][_eq]=published`);
        if (showAll) {
            params.push(`filter[private][_in]=true,false`);
        } else {
            params.push(`filter[private][_in]=false`);
        }
        const result = await axios.get(`${url}?${params.join("&")}`);
        return result.data.data;
    }

    getAssetUrl(name, resize) {
        const params = resize ? `fit=cover&width=${resize}` : "";
        return `${this.baseUrl}/assets/${name}?${params}`;
    }
}

const directusHelper = new DirectusHelper();
export default directusHelper;
